import React from 'react';
import { useTranslation } from 'react-i18next';
import Typography from '@src/new-components/Typography';
import { LANGUAGE } from '@src/constants';
import { StyledPrizes } from './index.style';

const PrizeSection = ({ images }) => {
  const { t, i18n } = useTranslation();
  const isVietnamese = i18n.language === LANGUAGE.VN;
  const taglineDesktop = isVietnamese
    ? images.prizesTaglineDesktopVi
    : images.prizesTaglineDesktopEn;
  const taglineMobile = isVietnamese
    ? images.prizesTaglineMobileVi
    : images.prizesTaglineMobileEn;

  const prizes = [
    {
      name: 'iPhone 18 Pro Max',
      rank: t('topPaidEventFirstPrize'),
      image: images.prizeIphone,
    },
    {
      name: 'iPad A16',
      rank: t('topPaidEventSecondPrize'),
      image: images.prizeIpad,
    },
    {
      name: 'AirPods 5',
      rank: t('topPaidEventThirdPrize'),
      image: images.prizeAirpods,
    },
  ];

  return (
    <StyledPrizes>
      <Typography
        variant="body-24-semibold"
        component="h2"
        className="section-title"
      >
        {t('topPaidEventPrizesTitle')}
      </Typography>
      <div className="tagline">
        <img className="tagline-arrow" src={images.prizesTaglineArrow} alt="" />
        <img
          className={isVietnamese ? undefined : 'tagline-tilted'}
          src={taglineDesktop}
          alt={t('topPaidEventPrizesTagline')}
        />
      </div>
      <img
        className="tagline-mobile"
        src={taglineMobile}
        alt={t('topPaidEventPrizesTagline')}
      />
      <div className="prize-list">
        {prizes.map((prize) => (
          <div className="prize" key={prize.name}>
            <img className="prize-image" src={prize.image} alt={prize.name} />
            <div className="prize-text">
              <Typography variant="body-14-semibold" className="prize-name">
                {prize.name}
              </Typography>
              <Typography variant="body-14-regular" className="slate-text">
                {prize.rank}
              </Typography>
            </div>
          </div>
        ))}
      </div>
    </StyledPrizes>
  );
};

export default PrizeSection;
